export enum TIME_PERIODS {
    RANGE = 'range',
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    YEARLY = 'yearly'
}

export enum RULE_MODIFIER {
    and = 'and',
    or = 'or',
    orNot = 'orNot',
    andNot = 'andNot'
}

export enum RULE_MODIFIER_MAP {
    and = 'and',
    or = 'or',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    orNot = 'or',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    andNot = 'and'
}

export enum USER_VISIBILITY {
    all = 'all',
    guest = 'guest',
    user = 'user'
}

export enum SEGMENTATION_MODE {
    customRules = 'customRules',
    segmentationTag = 'segmentationTag'
}
